import { call, put } from 'redux-saga/effects'

import { UpdateCompanyInputInterface } from '../../../interfaces/company'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { requestFailure, updateCompanySucceed } from '../actions'

export function* updateCompanySaga(
  companyApi: {
    updateCompany: (...args: any[]) => any
  },
  {
    payload: { companyId, companyDetail }
  }: {
    payload: { companyId: string; companyDetail: UpdateCompanyInputInterface }
  }
) {
  try {
    const { data } = yield call(
      companyApi.updateCompany,
      companyId,
      companyDetail
    )
    yield put(updateCompanySucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
